import { useEffect, useState } from "react";
import { validateEmail } from "../views/helpers";
import { loginUser, sendVerificationCode } from "../data/dataApi";
import { useLocation, useNavigate } from "react-router-dom";
import ChatbotLogo from "../images/chat-bot.svg";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import OtpInput from 'react-otp-input';
import ExclamationCircle from '../images/exclamation-circle.svg';
import { useUserState } from "../views/components/UserStateProvider";

const Login = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showVerificationScreen, setShowVerificationScreen] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationCodeError, setVerificationCodeError] = useState("");
  const [unexpectedError, setUnexpectedError] = useState("");
  const [verificationCodeResent, setVerificationCodeResent] = useState(false);

  const { setLoggedIn } = useUserState();

  const navigate = useNavigate();
  const location = useLocation();

  const authPreCheck = async (e, disableResend = false) => {
    e.preventDefault();
    setEmailError(null);

    setVerificationCodeResent(disableResend);

    if (validateEmail(email, setEmailError) === "success") {
      const response = await loginUser(email);

      if (response.success) {
        setShowVerificationScreen(true);
      } else if (response.error.field === "email") {
        setEmailError(response.error.message);
      } else if (!response.error.field) {
        setUnexpectedError(response.error.message);
      }
    }
  };

  const verifyCode = async e => {
    e.preventDefault();

    if (email && verificationCode) {
      const response = await sendVerificationCode(email, verificationCode);

      if (response.success) {
        setLoggedIn(true);
        navigate("/home", { replace: true });
      } else if (response.error.field === "code") {
        setVerificationCodeError(response.error.message);
      } else {
        setUnexpectedError(response.error.message);
      }
    } else if (!verificationCode) {
      setVerificationCodeError("Please enter a valid verification code.");
    } else {
      setUnexpectedError("Unexpected error occurred. Please try again.");
    }
  };

  return (
    <div id="login" className="d-flex">
      <div className="hero d-flex justify-content-center align-items-center position-relative flex-grow-1">
        <div className="overlay tif-py-50 tif-px-45 text-center position-relative d-md-block d-none tif-mx-15">
          <img src={ChatbotLogo} className="tif-mb-15" alt="Gelest AI chatbot logo" />
          <h1 className="tif-h2 tif-color-november tif-mb-0">Ask the bot for help finding an answer in any Gelest Document</h1>
        </div>
      </div>
      <div className="login-wrapper flex-shrink-0 tif-bg-color-white tif-py-sm-55 tif-py-25 tif-px-sm-60 tif-px-30 overflow-auto">
        <div className="header tif-mb-sm-140 tif-mb-70">
          <h2 className="tif-h3"><Link to="/"><img src={ChatbotLogo} className="login-header-logo tif-mr-25 align-bottom" alt="Gelest AI chatbot logo" /></Link>Gelest Navigator AI Assistant</h2>
        </div>

        {
          showVerificationScreen ?
            <>
              <h3 className="tif-h2 tif-mb-15 fw-light tif-color-november">Enter Verification Code</h3>
              <p className="tif-mb-sm-70 tif-mb-35 tif-ls-25">Please type in the code we just sent to {email} to login.</p>

              <Form className="primary-form" onSubmit={e => authPreCheck(e, true)}>
                <Form.Group>
                  <div id="otp">
                    <OtpInput
                      value={verificationCode}
                      onChange={setVerificationCode}
                      numInputs={6}
                      renderInput={(props) => <Form.Control {...props} />}
                    />
                  </div>
                </Form.Group>
                <div className="d-flex justify-content-between tif-mt-15">
                  {!verificationCodeResent ? <Button className="link-btn" onClick={e => authPreCheck(e, true)}>Resend Code</Button> : <></>}
                  {(verificationCodeError || unexpectedError) && <p className="error-text"><img src={ExclamationCircle} className="tif-mr-5" alt="Exclamation circle icon" />{verificationCodeError || unexpectedError}</p>}
                </div>

                <Button type="submit" className="primary-btn tif-mt-45" onClick={verifyCode}>Login</Button>
              </Form>
            </>
            :
            <>
              <h2 className="tif-h2 tif-mb-15 fw-light tif-color-november">Login</h2>
              <p className="tif-mb-sm-70 tif-mb-35 tif-ls-25">Please enter your email address to gain access to the AI Assistant. Only users with approved email addresses will receive a verification code.</p>

              <Form className="primary-form" onSubmit={authPreCheck}>
                <Form.Group controlId="formEmail">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control type="email" className={emailError ? "has-error" : ""} placeholder="example@email.com" value={email} onChange={e => setEmail(e.target.value)} />
                  {emailError && <p className="error-text">{emailError}</p>}
                </Form.Group>
                {unexpectedError && <p className="error-text">{unexpectedError}</p>}

                <Button className="primary-btn tif-mt-20" onClick={authPreCheck}>Send Verification Code</Button>
              </Form>
            </>
        }
      </div>
    </div>
  );
};

export default Login;